import { ELEMENT_PARAGRAPH } from "@udecode/plate";

export const trailingBlockPlugin = {
  options: { type: ELEMENT_PARAGRAPH },
};
